import RawCard from "./Card";
import CardContent from "./components/CardContent/CardContent";
import CardHeader from "./components/CardHeader/CardHeader";
import CardSubtitle from "./components/CardSubtitle/CardSubtitle";
import CardTitle from "./components/CardTitle/CardTitle";

export type { CardProps } from "./Card";

type CardComponent = typeof RawCard & {
  Header: typeof CardHeader;
  Title: typeof CardTitle;
  Subtitle: typeof CardSubtitle;
  Content: typeof CardContent;
};

const Card = RawCard as CardComponent;

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Content = CardContent;

export type { CardComponent };
export default Card;
export { CardContent, CardHeader, CardSubtitle, CardTitle };
